export default "__VITE_ASSET__986e050c__"